import { SEVERITY_LEVELS } from "../enum";

 
  export const calculateSeverity = (selectedSeverities) => {
    const severitySet = new Set(selectedSeverities);
    if (severitySet.has(SEVERITY_LEVELS.SEVERE)) return SEVERITY_LEVELS.SEVERE;
    if (severitySet.has(SEVERITY_LEVELS.MODERATE)) return SEVERITY_LEVELS.MODERATE;
    return null;
  };
  
  export const getSeverityLabel = (severity) => {
    switch (severity) {
      case SEVERITY_LEVELS.SEVERE:
        return 'Severe';
      case SEVERITY_LEVELS.MODERATE:
        return 'Moderate';
      default:
        return 'Unknown';
    }
  };
  